/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, auditorName: NonNullable<unknown>, count: NonNullable<unknown> }} Audit_Session_OptionInputs */

const en_audit_session_option = /** @type {(inputs: Audit_Session_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} — ${i?.auditorName} (${i?.count} items)`)
};

const es_audit_session_option = /** @type {(inputs: Audit_Session_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} — ${i?.auditorName} (${i?.count} articulos)`)
};

/**
* | output |
* | --- |
* | "{date} — {auditorName} ({count} items)" |
*
* @param {Audit_Session_OptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_session_option = /** @type {((inputs: Audit_Session_OptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Session_OptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_session_option(inputs)
	return es_audit_session_option(inputs)
});